module.exports = __webpack_public_path__ + "static/media/mta_logo.96f88e1e.png";